import React from 'react';
import { Link } from 'react-router-dom';
import { getAllPosts } from '../content/config';

const checkHead = async (url) => {
  try {
    const response = await fetch(url, { method: 'HEAD' });
    return {
      status: response.status,
      contentType: response.headers.get('content-type') || 'unknown',
      ok: response.ok
    };
  } catch (error) {
    return {
      status: 0,
      contentType: String(error?.message || 'network-error'),
      ok: false
    };
  }
};

const DebugCovers = () => {
  const posts = React.useMemo(() => getAllPosts().slice(0, 5), []);
  const [assets, setAssets] = React.useState({});
  const [postChecks, setPostChecks] = React.useState({});

  React.useEffect(() => {
    let active = true;

    const run = async () => {
      const baseChecks = await Promise.all([
        checkHead('/covers/default.webp'),
        checkHead('/covers/ia.webp')
      ]);

      if (!active) return;
      setAssets({
        '/covers/default.webp': baseChecks[0],
        '/covers/ia.webp': baseChecks[1]
      });

      const entries = await Promise.all(
        posts.map(async (post) => {
          const result = await checkHead(post.cover);
          return [post.slug, result];
        })
      );

      if (!active) return;
      setPostChecks(Object.fromEntries(entries));
    };

    run();
    return () => {
      active = false;
    };
  }, [posts]);

  const renderResult = (result) => {
    if (!result) return <span className="text-slate-400">pending...</span>;
    const isImage = String(result.contentType).toLowerCase().startsWith('image/');
    const stateClass = isImage ? 'text-emerald-600' : 'text-rose-600';
    return (
      <span className={stateClass}>
        {result.status} - {result.contentType}
      </span>
    );
  };

  return (
    <section className="mx-auto max-w-5xl px-4 py-10">
      <div className="mb-8 flex items-center justify-between">
        <h1 className="text-3xl font-black text-slate-900">Debug Covers</h1>
        <Link to="/" className="rounded-md border border-slate-300 px-3 py-1.5 text-sm text-slate-700 hover:bg-slate-50">
          Retour accueil
        </Link>
      </div>

      <div className="rounded-xl border border-slate-200 bg-white p-4">
        <h2 className="mb-3 text-sm font-bold uppercase tracking-wider text-slate-700">Assets critiques</h2>
        <ul className="space-y-2 text-sm">
          <li>
            <code className="mr-2 rounded bg-slate-100 px-1.5 py-0.5">/covers/default.webp</code>
            {renderResult(assets['/covers/default.webp'])}
          </li>
          <li>
            <code className="mr-2 rounded bg-slate-100 px-1.5 py-0.5">/covers/ia.webp</code>
            {renderResult(assets['/covers/ia.webp'])}
          </li>
        </ul>
      </div>

      <div className="mt-6 overflow-hidden rounded-xl border border-slate-200 bg-white">
        <table className="w-full text-left text-sm">
          <thead className="bg-slate-50 text-slate-700">
            <tr>
              <th className="px-4 py-3">Slug</th>
              <th className="px-4 py-3">Cover</th>
              <th className="px-4 py-3">HEAD result</th>
            </tr>
          </thead>
          <tbody>
            {posts.map((post) => (
              <tr key={post.slug} className="border-t border-slate-100 align-top">
                <td className="px-4 py-3 font-medium text-slate-800">{post.slug}</td>
                <td className="px-4 py-3">
                  <code className="rounded bg-slate-100 px-1.5 py-0.5 text-xs">{post.cover}</code>
                </td>
                <td className="px-4 py-3">{renderResult(postChecks[post.slug])}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default DebugCovers;
